import React, { useEffect, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faPenToSquare,
  faEllipsis,
  faSitemap,
  faPrint,
  faList,
  faTrash,
  faShare,
  faPlay,
  faFolderPlus,
  faFileArrowUp,
  faPaperPlane,
  faClipboardCheck,
  faPaste,
  faUserCheck,
  faKey,
  faLink
} from '@fortawesome/free-solid-svg-icons';
import Dropdown from 'react-bootstrap/Dropdown';
import { useAssignmentContext } from '../../assignments/context';
import {
  useGetAssignmentsByFilterMutation
} from '../../../features/authentication/authApiSlice';
import OptionTileModal from '../pages/AssignmentsAndActivities/Components/modals/OptionTileModal';
import DeleteMenuModal from './assignmentFloatingMenu/modals/DeleteMenuModal';
import {
  useExportXmlAssignmentsMutation
} from '../../../features/authentication/assignApiSlice';
import MoveMenuModal from './assignmentFloatingMenu/modals/MoveMenuModal';
import ShareMenuModal from './assignmentFloatingMenu/modals/ShareMenuModal';
import PublishMenuModal from './assignmentFloatingMenu/modals/PublishMenuModal';
import SubmitMenuModal from './assignmentFloatingMenu/modals/SubmitMenuModal';
import DuplicateMenuModal from './assignmentFloatingMenu/modals/DuplicateMenuModal';
import { useDashboardContext } from '../../dashboard/context';
import AssignMenuPreviewModal from './assignmentFloatingMenu/modals/AssignMenuPreviewModal';
import appConfig from '../../../app-config';
import { useSelector } from 'react-redux';
import { selectCurrentToken } from '../../../features/authentication/authSlice';
import CustomToast from '../../../components/Toast';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { useNavigate } from 'react-router-dom';
import AssignmentTable from './AssignmentTable';
import AssignMenuModal from './assignmentFloatingMenu/modals/AssignMenuModal';
import PropTypes from 'prop-types';
import { useGetSharedUsersMutation } from '../../../features/authentication/assignmentApislice';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import ActivityTypes from '../../../enums/activityTypes';

const baseUrl = appConfig.apiBaseUrl;
const CurrentAssignmentsList = ({ initialFilters }) => {
  const token = useSelector(selectCurrentToken);
  const [exportAssignment] = useExportXmlAssignmentsMutation();
  const [loadMoreData, setLoadMoreData] = useState([]);
  const [loadMegaDropDown, setLoadMegaDropDown] = useState([]);

  const selectedAssignment = useAssignmentContext();
  const [getAssignmentsByFilter] = useGetAssignmentsByFilterMutation();
  const [getSharedUsers] = useGetSharedUsersMutation();
  const [assignmentSortValue, setAssignmentSortValue] = useState(null);
  const [printingOptionsModal, setPrintingOptionsModal] = useState(false);
  const [deleteAssignmentsModal, setDeleteAssignmentsModal] = useState(false);
  const [moveAssignmentsModal, setMoveAssignmentsModal] = useState(false);
  const [publishAssignmentsModal, setPublishAssignmentsModal] = useState(false);
  const [submitAssignmentsModal, setSubmitAssignmentsModal] = useState(false);
  const [duplicateAssignmentsModal, setDuplicateAssignmentsModal] = useState(false);
  const [assignAssignmentsModal, setAssignAssignmentsModal] = useState(false);
  const [previewAssignmentModal, setPreviewAssignmentModal] = useState(false);
  const [filters, setFilters] = useState([]);
  const [newCourseId, setNewCourseId] = useState([]);
  const [newFolderId, setNewFolderId] = useState([]);
  const getData = useDashboardContext();
  const [skipValue, setSkipValue] = useState(0);
  const [sharedUsers, setSharedUsers] = useState([]);
  const [isCurrentPageSelected, setIsCurrentPageSelected] = useState(false);

  const {
    assignedData,
    setAssignedData,
    noOfAssignments,
    setNoOfAssignments,
    setAssignmentIdSend,
    setAssignmentId,
    assignmentId,
    assignedName,
    setAssignedName,
    assignedCourseName,
    setAssignedCourseName,
    assignmentName,
    setAssignmentName,
    setAssignmentAssignedViaDetails,
    setAssignedStatus,
    isAssignmentsAvailable,
    setNoOfAssignedStudents,
    setAssignedCount,
    setAssignmentCourseId,
    importPublicAssignmentCompleted
  } = useAssignmentContext();
  const [isLoading, setIsLoading] = useState(false);

  const getAllAssignmentsByFilterAsync = async (skip, take) => {
    try {
      const options = {
        skip,
        take
      };
      if (assignmentSortValue != null) options.sort = assignmentSortValue;
      options.assignmentStatus = selectedAssignment.filters.assignmentStatus;
      options.assignedVia = selectedAssignment.filters.assignedVia;
      options.searchText = selectedAssignment.selectedKeyWord;
      options.courseId = selectedAssignment.filters.courseId;
      options.folderId = selectedAssignment.filters.folderId;
      options.isSearch = Boolean(selectedAssignment.search);
      return await getAssignmentsByFilter(options).unwrap();
    } catch (error) {
      console.log(error);
    }
  };

  const validateSubmitAssignmentAsync = async (value, assignmentId) => {
    if (!isLoading) {
      setIsLoading(true);
      try {
        const options = {
          assignmentId: assignmentId
        };
        let url = baseUrl + '/Assignment/ValidateSubmitAssignment';
        url += '?assignmentId=' + options.assignmentId;
        const headers = {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        };
        const response = await fetch(url, { headers, method: 'GET' });
        const errorMsg = await response.text();
        const result = response.status;
        if (result === 200) {
          value.modal();
          setIsLoading(false);
        } else {
          CustomToast(`${errorMsg}`, 'warning');
          setIsLoading(false);
        }
      } catch (ex) {
        console.log(ex);
        setIsLoading(false);
      }
    }
  };

  useEffect(() => {
    if (importPublicAssignmentCompleted) {
      setAssignedData([]);
      setLoadMoreData([]);
      setSkipValue(0);
      selectedAssignment.setIsAllSelected(false);
      selectedAssignment.setSelectedCount(0);
    }
  }, [importPublicAssignmentCompleted]);

  useEffect(() => {
    if (initialFilters)
      setInitialFilters();
  }, [initialFilters]);

  const setInitialFilters = () => {
    setFilters(initialFilters);
    setNewCourseId(initialFilters?.courseId);
    setNewFolderId(initialFilters?.folderId);
    if(!selectedAssignment.search)
      selectedAssignment.setSelectedKeyWord('');
  };

  useEffect(() => {
    if (filters.courseId != undefined && isAssignmentsAvailable && !importPublicAssignmentCompleted) {
      if (selectedAssignment.search) {
        setAssignedData([]);
        setNewCourseId(selectedAssignment.selectedCourseId);
        setNewFolderId(selectedAssignment.selectedFolderId);
        selectedAssignment.setSearch(false);
      }
      if (assignmentSortValue || selectedAssignment.search) {
        setLoadMoreData([]);
        setSkipValue(0);
      }
      loadInitialData();
    }
  }, [
    assignmentSortValue,
    selectedAssignment.assignedDataStatus,
    filters
  ]);

  const loadInitialData = async () => {
    setIsLoading(true);
    const { total, data } = await getAllAssignmentsByFilterAsync(0, filters.takeSize);
    distinctObjects(data);
    setNoOfAssignments(total);
    setIsLoading(false);
    setIsCurrentPageSelected(false);
    selectedAssignment.setIsAllSelected(false);
  };

  const nextCallback = async (newOffset) => {
    setIsLoading(true);
    setSkipValue(newOffset);
    const { total, data } = await getAllAssignmentsByFilterAsync(newOffset, filters.takeSize);
    let newItems = [...loadMoreData, ...data];
    if (isCurrentPageSelected) {
      newItems = newItems.map((item) => {
        return { ...item, isChecked: true };
      });
    }
    distinctObjects(newItems);
    setNoOfAssignments(total);
    setIsLoading(false);
  };

  const distinctObjects = (data) => {
    var distinctData = Array.from(
      data.reduce((map, obj) => map.set(obj.assignmentId, obj), new Map()).values()
    );
    setLoadMoreData(distinctData);
  };

  const megaListDropdown = () => {
    const megaDropdown = [
      {
        id: 'duplicate',
        name: 'Duplicate',
        icon: <FontAwesomeIcon icon={faPaste} />,
        modal: () => setDuplicateAssignmentsModal(!duplicateAssignmentsModal)
      },
      {
        id: 'previewAssignment',
        name: 'Preview Assignment',
        icon: <FontAwesomeIcon icon={faPlay} />,
        modal: () => setPreviewAssignmentModal(!previewAssignmentModal)
      },
      {
        id: 'viewChanges',
        name: 'View Assignment Changes',
        icon: <FontAwesomeIcon icon={faSitemap} />,
        link: `manage_assign/reports/assignment_changes_report/${ActivityTypes.Assignment}`
      },
      {
        id: 'moveToFolder',
        name: 'Move to Folder',
        icon: <FontAwesomeIcon icon={faFolderPlus} />,
        modal: () => setMoveAssignmentsModal(!moveAssignmentsModal)
      },
      {
        id: 'printAssignment',
        name: 'Print Assignment/Key',
        icon: <FontAwesomeIcon icon={faPrint} />
      },
      {
        id: 'exportToXML',
        name: 'Export to XML',
        icon: <FontAwesomeIcon icon={faFileArrowUp} />
      },
      {
        id: 'displayVocabulary',
        name: 'Display/Print Vocabulary',
        icon: <FontAwesomeIcon icon={faList} />,
        link: 'vocabularyPrinting'
      },
      {
        id: 'makePublic',
        name: 'Make Public',
        icon: <FontAwesomeIcon icon={faPaperPlane} />,
        modal: () => setPublishAssignmentsModal(!publishAssignmentsModal)
      },
      {
        id: 'deleteAssignment',
        name: 'Delete Assignment',
        icon: <FontAwesomeIcon icon={faTrash} />,
        modal: () => setDeleteAssignmentsModal(!deleteAssignmentsModal)
      },
      {
        id: 'submitAsBenchmark',
        name: 'Submit as Benchmark',
        icon: <FontAwesomeIcon icon={faClipboardCheck} />,
        modal: () => setSubmitAssignmentsModal(!submitAssignmentsModal)
      },
      {
        id: 'sendCopy',
        name: 'Send Copy',
        icon: <FontAwesomeIcon icon={faShare} />
      },
      {
        id: 'createLink',
        name: 'Create Assignment Link',
        icon: <FontAwesomeIcon icon={faLink} />,
        modal: (item) => handleCreateLink(item)
      }
    ];
    setLoadMegaDropDown(megaDropdown);
  };

  const handleCreateLink = (item) => {
    selectedAssignment.setAssignedData([item]);
    setAssignAssignmentsModal(true);
  };

  const handleChange = (e) => {
    const { name, checked } = e.target;
    if (name === 'allselect') {
      let tempLoadMoreData = loadMoreData.map((item) => {
        return { ...item, isChecked: checked };
      });
      setLoadMoreData(tempLoadMoreData);
      setAssignedData(tempLoadMoreData.filter((item) => item.isChecked));
      setIsCurrentPageSelected(!isCurrentPageSelected);
      const selectedCount = tempLoadMoreData.filter(item => item.isChecked)?.length;
      selectedAssignment.setIsAllSelected((noOfAssignments == selectedCount && noOfAssignments <= filters.takeSize));
      selectedAssignment.setSelectedCount(selectedCount);
    } else {
      const id = parseInt(name);
      let loadMoreDataArray = loadMoreData.map((item) =>
        item.assignmentId === id ? { ...item, isChecked: checked } : item
      );
      const selectedCount = loadMoreDataArray.filter(item => item.isChecked).length;
      setIsCurrentPageSelected(selectedCount == loadMoreData.length);
      selectedAssignment.setIsAllSelected((noOfAssignments == selectedCount && noOfAssignments <= filters.takeSize));
      selectedAssignment.setSelectedCount(selectedCount);
      const selectedData = loadMoreData.find((item) => item.assignmentId === id);

      const assignmentNames = [];
      const courseNames = [];
      // assignmentNameArray
      if (assignedName.includes(selectedData.assignmentName)) {
        setAssignedName(assignedName.filter((item) => item !== selectedData.assignmentName));
      } else {
        assignmentNames.push(...assignedName, selectedData.assignmentName);
        setAssignedName(assignmentNames);
      }
      // courseNameArray
      if (assignedCourseName.includes(selectedData.courseName)) {
        setAssignedCourseName(
          assignedCourseName.filter((item) => item !== selectedData.courseName)
        );
      } else {
        courseNames.push(...assignedCourseName, selectedData.courseName);
        setAssignedCourseName(courseNames);
      }

      let assignedDataArray = [];
      if (
        assignedData.filter((item) => item.assignmentId === selectedData.assignmentId).length > 0
      ) {
        setAssignedData(
          assignedData.filter((item) => item.assignmentId !== selectedData.assignmentId)
        );
      } else {
        assignedDataArray.push(...assignedData, selectedData);
        setAssignedData(assignedDataArray);
      }
      setLoadMoreData(loadMoreDataArray);
    }
  };

  useEffect(() => {
    megaListDropdown();
  }, []);

  const exportAssignmentMenu = async (id) => {
    try {
      const option = {
        assignmentIds: [id]
      };

      const blob = await exportAssignment(option).unwrap();

      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.download = 'CastleXMLAssignments.xml';
      link.href = url;
      link.click();
      URL.revokeObjectURL(url);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (selectedAssignment.assignedViaUpdate) {
      const updatedArray = loadMoreData?.map((item1) => {
        const matchingItem2 = assignedData?.find(
          (item2) => item2.assignmentId === item1.assignmentId
        );
        if (matchingItem2) {
          return { ...item1, assignedVia: matchingItem2.assignedVia };
        }
        return item1;
      });
      setLoadMoreData(updatedArray);
      selectedAssignment.setAssignedViaUpdate(false);
    }
  }, [assignedData]);

  const handlePrintingOptions = (e) => {
    const id = e.currentTarget.id;
    const option = printOptions.map((item) =>
      item.id === id ? { ...item, isActive: true } : { ...item, isActive: false }
    );
    if (id === 'standardPrinting') {
      const url = `${assignmentId}/standardPrinting`;
      setNavigation(url);
    } else {
      const url = `${assignmentId}/answerKey`;
      setNavigation(url);
    }
    setPrintOptions(option);
  };

  const printingOptions = [
    {
      id: 'standardPrinting',
      icon: <FontAwesomeIcon icon={faPrint} className="printing-icon" />,
      label: 'Standard Assignment Printing',
      isActive: true
    },
    {
      id: 'answerKey',
      icon: <FontAwesomeIcon icon={faKey} className="printing-icon" />,
      label: 'Answer Key',
      isActive: false
    }
  ];
  const [printOptions, setPrintOptions] = useState(printingOptions);
  const [navigation, setNavigation] = useState('');
  const handlePrintAssignment = (assignmentId, assignmentName) => {
    setPrintingOptionsModal(!printingOptionsModal);
    setAssignmentId(assignmentId);
    setNavigation(`${assignmentId}/standardPrinting`);
    setAssignmentName(assignmentName);
    setPrintOptions(printingOptions);
  };

  const handlePrintOptionContinue = () => {
    navigate(navigation, { state: { assignmentId: assignmentId, assignmentName: assignmentName } });
  };

  const navigate = useNavigate();

  const generateMoreOptions = (item, index) => {
    return (
      <div className="action-btns d-flex justify-content-end gap-2">
        <NavLink
          onClick={() => {
            setAssignmentId(item.assignmentId);
            setAssignmentName(item.assignmentName);
            setAssignedCourseName([item.courseName]);
            setAssignmentAssignedViaDetails({ id: item.assignedVia });
            setAssignedStatus(item.assignedStatus);
            setNoOfAssignedStudents(item.assignedCount);
          }}
          end
          to={`${item.assignmentId}/manage_assign`}>
          <ReactTooltip
            id={`manage-${index}`}
            place="top"
            content="Manage/Assign"
            className="list-tooltip z-index10"
          />
          <button id={`manage${item.assignmentId}`} data-tooltip-id={`manage-${index}`}>
            <FontAwesomeIcon icon={faUserCheck} />
          </button>
        </NavLink>
        <NavLink
          end
          to={`${item.assignmentId}/edit_assignment`}
          onClick={() => {
            setAssignmentId(item.assignmentId);
            setAssignmentName(item.assignmentName);
            setAssignmentCourseId(item.courseId);
            setAssignmentAssignedViaDetails({ id: item.assignedVia });
          }}
          state={{ assignedStatus: item.assignedStatus, mcChoices: selectedAssignment.mcChoices, assignedViaDetails: { id: item.assignedVia } }}>
          <ReactTooltip
            id={`view-${index}`}
            place="top"
            content="View/Edit Assignment"
            className="list-tooltip z-index10"
          />
          <button
            id={`edit-${item.assignmentId}`}
            style={{ disabled: 'disabled' }}
            data-tooltip-id={`view-${index}`}>
            <FontAwesomeIcon icon={faPenToSquare} />
          </button>
        </NavLink>
        <div className="position-relative">
          <ReactTooltip
            id={`moreactions-${index}`}
            place="top"
            content="More Actions"
            className="list-tooltip z-index10"
          />
          <Dropdown
            data-tooltip-id={`moreactions-${index}`}
            onToggle={(isOpen) => {
              if (isOpen) {
                handleGetSharedUsers(item.assignmentId);
              }
            }}
          >
            <Dropdown.Toggle>
              <FontAwesomeIcon icon={faEllipsis} />
            </Dropdown.Toggle>
            <Dropdown.Menu className="more-dropdown assignment-more p-3 pe-0">
              {loadMegaDropDown.map((val, arrayKey) => {
                if (val.id === 'viewChanges' || val.id === 'displayVocabulary') {
                  return (
                    <Dropdown.Item
                      key={`drop-${arrayKey}`}
                      as={Link}
                      to={`${item.assignmentId}/${val.link}`}
                      className='d-flex align-items-center'
                      state={{
                        assignmentName: item.assignmentName,
                        assignmentId: item.assignmentId
                      }}>
                      {val.icon}
                      {val.name}
                    </Dropdown.Item>
                  );
                } else if (val.id === 'printAssignment') {
                  return (
                    <Dropdown.Item
                      key={`drop-${arrayKey}`}
                      className='d-flex align-items-center'
                      onClick={() => handlePrintAssignment(item.assignmentId, item.assignmentName)}>
                      {val.icon}
                      {val.name}
                    </Dropdown.Item>
                  );
                } else if (val.id === 'exportToXML') {
                  return (
                    <Dropdown.Item
                      key={`drop-${arrayKey}`}
                      className='d-flex align-items-center'
                      onClick={() => exportAssignmentMenu(item.assignmentId)}>
                      {val.icon}
                      {val.name}
                    </Dropdown.Item>
                  );
                } else if (val.id === 'sendCopy') {
                  return (
                    <Dropdown.Item
                      key={`drop-${arrayKey}`}
                      className='d-flex align-items-center'
                      onClick={() => {
                        getData.setSelectRecipient(true);
                        setAssignmentIdSend([item.assignmentId]);
                        setAssignmentName(item.assignmentName);
                      }}>
                      {val.icon}
                      {val.name}
                      {generateSharedUsersTooltip()}
                    </Dropdown.Item>
                  );
                } else if (val.id === 'makePublic') {
                  return (
                    <Dropdown.Item
                      key={`drop-${arrayKey}`}
                      className='d-flex align-items-center'
                      onClick={() => {
                        validateSubmitAssignmentAsync(val, item.assignmentId);
                        setAssignmentId(item.assignmentId);
                        setAssignmentName(item.assignmentName);
                        setAssignedName([item.assignmentName]);
                        setAssignedCourseName([item.courseName]);
                        setAssignmentAssignedViaDetails({ id: item.assignedVia });
                      }}
                      disabled={isLoading}>
                      {val.icon}
                      {val.name}
                    </Dropdown.Item>
                  );
                } else if (val.id === 'submitAsBenchmark') {
                  return (
                    <Dropdown.Item
                      key={`drop-${arrayKey}`}
                      className='d-flex align-items-center'
                      onClick={() => {
                        validateSubmitAssignmentAsync(val, item.assignmentId);
                        setAssignmentId(item.assignmentId);
                        setAssignmentName(item.assignmentName);
                        setAssignedName([item.assignmentName]);
                        setAssignedCourseName([item.courseName]);
                        setAssignmentAssignedViaDetails({ id: item.assignedVia });
                      }}
                      disabled={isLoading}>
                      {val.icon}
                      {val.name}
                    </Dropdown.Item>
                  );
                } else if ((val.id === 'createLink' && (item.assignedVia == 2 || item.assignedVia == 3)) || val.id !== 'createLink') {
                  return (
                    <Dropdown.Item
                      key={`drop-${arrayKey}`}
                      className='d-flex align-items-center'
                      onClick={() => {
                        val.modal(item);
                        setAssignedCount(item.assignedCount);
                        setAssignmentId(item.assignmentId);
                        setAssignmentName(item.assignmentName);
                        setAssignedName([item.assignmentName]);
                        setAssignedCourseName([item.courseName]);
                        setAssignmentAssignedViaDetails({ id: item.assignedVia });
                      }}>
                      {val.icon}
                      {val.name}
                    </Dropdown.Item>
                  );
                }
              })}
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>
    );
  };

  const handleGetSharedUsers = async (id) => {
    setSharedUsers([]);
    var response = await getSharedUsers(id);
    if (response.error) {
      return CustomToast(response.error.data.error, 'error');
    }
    setSharedUsers(response.data);
  };

  const generateSharedUsersTooltip = () => {
    if (sharedUsers.length === 0) return null;
    const tooltip = (
      <Tooltip className="custom-tooltip">
        {sharedUsers.map((user) => `${user.lName} ${user.fName}`).join(', ')}
      </Tooltip>
    );

    return (
      <OverlayTrigger key="assignedVia" placement="top" overlay={tooltip}>
        <div className="megadropdown-count mx-1" style={{ cursor: 'pointer' }}>
          <span>{sharedUsers.length}</span>
        </div>
      </OverlayTrigger>
    );
  };

  return (
    <>
      {(selectedAssignment.isAllSelected && isCurrentPageSelected) ?
        <div>All selected</div>
        :
        isCurrentPageSelected ?
          <div className='mb-2'>All <strong>{loadMoreData.length}</strong> assignments in this page are selected. <span className='text-info cursor-pointer' onClick={() => selectedAssignment.setIsAllSelected(true)}>Select all assignments that matches this search</span></div>
          : ''
      }
      <div className="assignment-table table-responsive mt-2">
        <AssignmentTable
          isAssignment={true}
          data={loadMoreData}
          nextCallback={nextCallback}
          skipValue={skipValue}
          limit={filters.takeSize}
          totalCount={noOfAssignments}
          setAssignmentSortValue={setAssignmentSortValue}
          filters={filters}
          setFilters={setFilters}
          folderId={newFolderId}
          courseId={newCourseId}
          moreOption={generateMoreOptions}
          handleSelect={handleChange}
          isLoading={isLoading}
          isCurrentPageSelected={isCurrentPageSelected}
        />
      </div>

      {printingOptionsModal &&
        <OptionTileModal
          isOpen={printingOptionsModal}
          onClose={() => setPrintingOptionsModal(false)}
          title={'Select Print Option'}
          options={printOptions}
          handleOptionClick={handlePrintingOptions}
          saveLabel={'Continue'}
          handleSaveClick={handlePrintOptionContinue}
        />
      }

      {moveAssignmentsModal && (
        <MoveMenuModal
          modalData={moveAssignmentsModal}
          setModalData={setMoveAssignmentsModal}
          fromMoreActions={true}
          activityType={ActivityTypes.Assignment}
        />
      )}

      <PublishMenuModal
        modalData={publishAssignmentsModal}
        setModalData={setPublishAssignmentsModal}
        fromMoreActions={true}
        activityType={ActivityTypes.Assignment}
      />
      <ShareMenuModal
        assignmentId={selectedAssignment?.assignedData?.map((item) => item.assignmentId)}
        fromMoreAction={true}
      />
      <SubmitMenuModal
        modalData={submitAssignmentsModal}
        setModalData={setSubmitAssignmentsModal}
        fromMoreActions={true}
      />
      <DuplicateMenuModal
        modalData={duplicateAssignmentsModal}
        setModalData={setDuplicateAssignmentsModal}
        fromMoreActions={true}
        activityType={ActivityTypes.Assignment}
      />
      {deleteAssignmentsModal && (
        <DeleteMenuModal
          modalData={deleteAssignmentsModal}
          setModalData={setDeleteAssignmentsModal}
          fromMoreActions={true}
          activityType={ActivityTypes.Assignment}
        />
      )}
      {/* preview modal */}
      <AssignMenuPreviewModal
        modalData={previewAssignmentModal}
        setModalData={setPreviewAssignmentModal}
      />
      {assignAssignmentsModal &&
        <AssignMenuModal
          modalData={assignAssignmentsModal}
          setModalData={setAssignAssignmentsModal}
          enableCreateLink={true}
          fromMoreActions={true}
        />
      }
    </>
  );
};

CurrentAssignmentsList.propTypes = {
  initialFilters: PropTypes.object
};

export default CurrentAssignmentsList;
